import * as React from 'react';
import { createContext } from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useIntl } from '@grandvisionhq/state';
import { createImpressionEvent, createInteractionEvent } from '../Events/ProductPromotionEvents.js';

const context = {
    trackImpression: ()=>undefined
    ,
    trackInteraction: ()=>undefined
};
const ProductPromotionEventContext = /*#__PURE__*/ createContext(context);
const useProductPromotionEventContext = ()=>{
    return React.useContext(ProductPromotionEventContext);
};
const ProductPromotionEventProvider = ({ children , location  })=>{
    const { currency  } = useIntl();
    const handleImpression = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createImpressionEvent(product, position, location, currency));
    }, [
        currency,
        location
    ]);
    const handleInteraction = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, location, currency));
    }, [
        currency,
        location
    ]);
    return /*#__PURE__*/ React.createElement(ProductPromotionEventContext.Provider, {
        value: {
            trackImpression: handleImpression,
            trackInteraction: handleInteraction
        }
    }, children);
};

export { ProductPromotionEventProvider, useProductPromotionEventContext };
//# sourceMappingURL=ProductPromotionEventContext.js.map
